import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Modules Countries',
  basePath: '/modules-countries',
  columns: [
    { key: 'module', label: 'Module', sortable: true },
    { key: 'country', label: 'Country', sortable: true },
  ],
  fields: [
    { key: 'module', label: 'Module', type: 'text', required: true },
    { key: 'country', label: 'Country', type: 'text', required: true },
  ],
  defaultSort: { field: 'module', dir: 'asc' },
});
